export enum VatTypeEnum {
    VatNo = 0,
    Vat0 = 1,
    Vat18 = 2,
    Other = 3,
}

